import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 4V20C1 20.5523 1.44772 21 2 21H22C22.5523 21 23 20.5523 23 20V7C23 6.44772 22.5523 6 22 6H12L9.58579 3.58579C9.21071 3.21071 8.70201 3 8.17157 3H2C1.44772 3 1 3.44772 1 4Z",
		fill: "#B3B3B3"
	})
});
export default SvgFolderIcon;
